<template>
  <div>
    <div class="title">账号中心</div>
    <div class="content" v-if="companyDetail">
      <div class="set_wrap">
        <div class="header companycenter-txt">
          <img
                  :src="companyDetail.pic?companyDetail.pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'"
                  alt
                  class="logo_img"
                  width="100"
                  height="100"
          >
          <div class="change" style="float: none;">
              <span @click="showCropper" class="changeBox">点击上传</span><el-tooltip class="item" effect="light" placement="bottom-start">
              <div slot="content" class="infocontent">
                该Logo将显示在企管后台，以及作为企<br>业动态中公司的头像
              </div>
              <i class="iconfont iconbangzhu1"></i>
            </el-tooltip>
          </div>
        </div>
        <div>
          <div class="account-row">
            <div class="row-left">企业简称</div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.name}}</div>
              <div class="change">
                <el-button size="mini" @click="editCompanyInfo(0)" class="editInfo" type="text">修改</el-button>
                <div class="right-line">
                  <el-tooltip placement="bottom-end" effect="light">
                    <div slot="content" class="infocontent">
                      企业简称将显示在企业动态、后台名称、AI名片姓名下
                    </div>
                    <i class="iconfont iconbangzhu1"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">企业名称</div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.company_name}}</div>
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">企业简介</div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.company_signtrue?companyDetail.company_signtrue:'暂无数据'}}</div>
              <div class="change">
                <el-button size="mini" @click="editCompanyInfo(4)" type="text" class="editInfo">修改</el-button>
                <div class="right-line"></div>
              </div>
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">名片数量</div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.create_number}}/{{companyDetail.card_num}}</div>
              <div class="change">
                <div class="right-line">
                  <el-tooltip placement="bottom-end" effect="light">
                    <div slot="content" class="infocontent">
                      数值为“已开通数/最大开通数”，若<br>需要增加最大开通数，请联系你的<br>代理商
                    </div>
                    <i class="iconfont iconbangzhu1"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">到期时间</div>
            <div class="row-right">{{companyDetail.expire_time}}</div>
          </div>
          <div class="account-row">
            <div class="row-left">公司地址</div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.company_address?companyDetail.company_address:'暂无数据.立即添加'}}
              </div>
              <div class="change">
                <el-button size="mini" @click="editCompanyInfo(1)" type="text" class="editInfo">修改</el-button>
                <div class="right-line"></div>
              </div>
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">
              手机号
            </div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.phone}}</div>
              <!-- <div class="change">
                <el-button size="mini" @click="editCompanyInfo(2,1)" type="text" class="editInfo">修改</el-button>
                <div class="right-line">
                  <el-tooltip placement="bottom-end" effect="light">
                    <div slot="content" class="infocontent">
                      该手机同时作为本账号的登录账号，成功修改后登录账号也将被修改
                    </div>
                    <i class="iconfont iconbangzhu1"></i>
                  </el-tooltip>
                </div>
              </div> -->
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">
              登录账号
            </div>
            <div class="row-right">
              <div class="row-right-desc">{{companyDetail.username}}</div>
              <!-- <div class="change">
                <el-button size="mini" @click="editCompanyInfo(2,2)" type="text" class="editInfo">修改</el-button>
                <div class="right-line">
                  <el-tooltip placement="bottom-end" effect="light">
                    <div slot="content" class="infocontent">
                      成功修改后登录账号也将被修改
                    </div>
                    <i class="iconfont iconbangzhu1"></i>
                  </el-tooltip>
                </div>
              </div> -->
            </div>
          </div>
          <div class="account-row">
            <div class="row-left">登录密码</div>
            <div class="row-right">
              <div class="row-right-desc">**********</div>
              <div class="change">
                <el-button size="mini" @click="editCompanyInfo(3)" type="text" class="editInfo">修改</el-button>
                <div class="right-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <enterpriseAbbreviationDialog :visible.sync="abbreviationdialog"
                                  v-if="abbreviationdialog" :formData="editForm"
                                  @editFrom="submitCompanyInfo"></enterpriseAbbreviationDialog>
    <enterpriseAddressDialog :visible.sync="addressdialog" v-if="addressdialog" :formData="editForm"
                             @editFrom="submitCompanyInfo"></enterpriseAddressDialog>
    <enterpriseAuthPhoneDialog :visible.sync="authphonedialog" v-if="authphonedialog" :formData="editForm"
                               @editFrom="submitCompanyInfo" :editType="editType"></enterpriseAuthPhoneDialog>
    <enterprisePasswordDialog :visible.sync="passworddialog" v-if="passworddialog" :formData="editForm"
                              @editFrom="submitCompanyInfo"></enterprisePasswordDialog>
    <enterpriseDescDialog :visible.sync="companySigntrue" v-if="companySigntrue" :formData="editForm"
                          @editFrom="submitCompanyInfo"></enterpriseDescDialog>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="sizeType"></corpper>
  </div>
</template>

<script>
  import enterpriseAbbreviationDialog from "@/components/dialog/enterpriseAbbreviationDialog.vue";
  import enterpriseAddressDialog from "@/components/dialog/enterpriseAddressDialog.vue";
  import enterpriseAuthPhoneDialog from "@/components/dialog/enterpriseAuthPhoneDialog.vue";
  import enterprisePasswordDialog from "@/components/dialog/enterprisePasswordDialog.vue";
  import enterpriseDescDialog from "@/components/dialog/enterpriseDescDialog.vue";
  import corpper from "@/components/dialog/corpper.vue";
  import api from "@/api.js"

  export default {
    name: "enterprise",
    components: {
      enterpriseAbbreviationDialog,
      enterpriseAddressDialog,
      enterpriseAuthPhoneDialog,
      enterprisePasswordDialog,
      enterpriseDescDialog,
      corpper
    },
    data() {
      return {
        corppervisible:false,
        sizeType:6,
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        imageUrl: "",
        abbreviationdialog: false,
        addressdialog: false,
        authphonedialog: false,
        mapdialog: false,
        passworddialog: false,
        companySigntrue: false,
        companyDetail: null,
        editForm: {
          pic: '',
          name: '',
          company_name: '',
          company_address: '',
          phone: '',
          company_signtrue: '',
          location: ''
        },
        editType: null
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post('companyadmin/company/index', {})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in this.editForm) {
                  this.editForm[i] = response.data.info[i]
                }
                this.companyDetail = response.data.info
              } else {
              }
            })
            .catch(response => {
            });
      },
      initPage() {
        this.InitFn();
      },
      editCompanyInfo(option, type) {
        // option 0 企业简称; 1 公司地址; 2 登入手机号; 3 登入密码
        if (option === 0) {
          this.abbreviationdialog = true;
        } else if (option === 1) {
          this.addressdialog = true;
        } else if (option === 2) {
          this.editType = type
          this.authphonedialog = true;
        } else if (option === 3) {
          this.passworddialog = true;
        } else if (option === 4) {
          // company_signtrue
          this.companySigntrue = true;
        }
      },
      showCropper(){
        this.corppervisible = true
      },
      imgAddBack(option){
        this.editForm.pic = option
        this.submitCompanyInfo()
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editForm.pic = res.path
        this.submitCompanyInfo()
        this.loadingStatus.close();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
        return isLt2M;
      },
      submitCompanyInfo() {
        this.axios
            .post('companyadmin/company/edit', this.editForm)
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn()
                this.abbreviationdialog = false;
                this.addressdialog = false;
                this.authphonedialog = false;
                this.passworddialog = false;
                this.companySigntrue = false;
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>
<style>
  .changeBox{
    color: #66b1ff;
    font-size: 14px;
  }
</style>
